import {
  FETCH_ALL_USERS,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_USERS_FAILED,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  EDIT_USER_FAILED,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILED,
  FETCH_ALL_USERS_STATIC,
  FETCH_ALL_USERS_STATIC_SUCCESS,
  FETCH_ALL_USERS_STATIC_FAILED,
  USER_DELETED,
  FETCH_ALL_DRIVERS,
  FETCH_ALL_DRIVERS_SUCCESS,
  FETCH_ALL_DRIVERS_FAILED
} from "../store/types";
import { getSupabase, createIsolatedSupabaseClient } from "../config/configureSupabase";
import { uploadMedia } from "../other/supabaseStorage";
import { getAuthRedirectUrl } from "./authactions";
import store from "../store/store";

const mapProfileToUser = (p) => {
  const resolvedUsertype = p.usertype || p.role || (p.is_superadmin ? 'superadmin' : 'customer');
  return {
    ...p,
    id: p.id,
    uid: p.id,
    firstName: p.first_name || p.firstName || '',
    lastName: p.last_name || p.lastName || '',
    mobile: p.mobile || '',
    email: p.email || '',
    usertype: resolvedUsertype,
    role: resolvedUsertype,
    tenant_id: p.tenant_id || p.tenantId || null,
    tenantId: p.tenant_id || p.tenantId || null,
    driverActiveStatus: p.driver_active_status !== undefined ? p.driver_active_status : (p.driverActiveStatus || false),
    approved: p.approved !== false,
    createdAt: p.created_at || p.createdAt || null
  };
};

export const fetchUsers = () => async (dispatch) => {
  dispatch({
    type: FETCH_ALL_DRIVERS,
    payload: null
  });

  const supabase = getSupabase();
  if (supabase) {
    try {
      const userInfo = store.getState().auth?.profile;
      const isSuperAdmin = Boolean(
        userInfo?.is_superadmin ||
        userInfo?.role === 'superadmin' ||
        userInfo?.usertype === 'superadmin'
      );
      let query = supabase.from('profiles').select('*');
      if (userInfo?.tenant_id && !isSuperAdmin) {
        query = query.eq('tenant_id', userInfo.tenant_id);
      }
      const { data, error } = await query;
      if (!error && data) {
        dispatch({
          type: FETCH_ALL_USERS_SUCCESS,
          payload: data.map(mapProfileToUser)
        });
        return;
      }
    } catch (e) {
      console.warn('fetchUsers error:', e);
    }
  }

  dispatch({
    type: FETCH_ALL_USERS_FAILED,
    payload: "No users available."
  });
};

export const fetchUsersOnce = () => async (dispatch) => {
  dispatch({
    type: FETCH_ALL_USERS_STATIC,
    payload: null
  });

  const supabase = getSupabase();
  if (supabase) {
    try {
      const userInfo = store.getState().auth?.profile;
      const isSuperAdmin = Boolean(
        userInfo?.is_superadmin ||
        userInfo?.role === 'superadmin' ||
        userInfo?.usertype === 'superadmin'
      );
      let query = supabase.from('profiles').select('*');
      if (userInfo?.tenant_id && !isSuperAdmin) {
        query = query.eq('tenant_id', userInfo.tenant_id);
      }
      const { data, error } = await query;
      if (!error && data) {
        dispatch({
          type: FETCH_ALL_USERS_STATIC_SUCCESS,
          payload: data.map(mapProfileToUser)
        });
        return;
      }
    } catch (e) {
      console.warn('fetchUsersOnce error:', e);
    }
  }

  dispatch({
    type: FETCH_ALL_USERS_STATIC_FAILED,
    payload: "No users available."
  });
};

export const clearFetchDrivers = () => () => {};

export const fetchDrivers = (appType) => async (dispatch) => {
  dispatch({
    type: FETCH_ALL_USERS,
    payload: null
  });

  const supabase = getSupabase();
  if (supabase) {
    try {
      const userInfo = store.getState().auth?.profile;
      let query = supabase.from('profiles').select('*').eq('usertype', 'driver');
      if (userInfo?.tenant_id) {
        query = query.eq('tenant_id', userInfo.tenant_id);
      }
      const { data, error } = await query;
      if (!error && data) {
        dispatch({
          type: FETCH_ALL_DRIVERS_SUCCESS,
          payload: data.map(mapProfileToUser)
        });
        return;
      }
    } catch (e) {
      console.warn('fetchDrivers error:', e);
    }
  }

  dispatch({
    type: FETCH_ALL_DRIVERS_FAILED,
    payload: "No users available."
  });
};

export const createUserWithAuth = (userdata) => async (dispatch) => {
  dispatch({
    type: EDIT_USER,
    payload: userdata
  });

  try {
    const isolatedClient = createIsolatedSupabaseClient();
    if (!isolatedClient) {
      throw new Error('Cliente Supabase não inicializado');
    }

    const email = userdata.email?.trim().toLowerCase();
    if (!email) {
      throw new Error('E-mail é obrigatório para cadastrar o usuário');
    }

    // Senha padrão temporária caso não informada (usuário poderá trocar ou confirmar via link)
    const rawPass = userdata.password || `AG#${Math.random().toString(36).slice(-6)}!${Math.floor(100 + Math.random() * 900)}`;

    // Upload de mídias/documentos se fornecidas como File/Blob
    let profileImageUrl = typeof userdata.profile_image === 'string' ? userdata.profile_image : null;
    let licenseImageUrl = typeof userdata.license_image === 'string' ? userdata.license_image : null;
    let licenseImageBackUrl = typeof userdata.license_image_back === 'string' ? userdata.license_image_back : null;
    let verifyIdImageUrl = typeof userdata.verify_id_image === 'string' ? userdata.verify_id_image : null;

    const filePrefix = `${Date.now()}_${Math.random().toString(36).substring(2, 7)}`;
    if (userdata.profile_image_file) {
      profileImageUrl = await uploadMedia('media', `profiles/${filePrefix}/avatar.jpg`, userdata.profile_image_file, userdata.profile_image_file.type || 'image/jpeg');
    }
    if (userdata.license_image_file) {
      licenseImageUrl = await uploadMedia('media', `documents/${filePrefix}/license_front.jpg`, userdata.license_image_file, userdata.license_image_file.type || 'image/jpeg');
    }
    if (userdata.license_image_back_file) {
      licenseImageBackUrl = await uploadMedia('media', `documents/${filePrefix}/license_back.jpg`, userdata.license_image_back_file, userdata.license_image_back_file.type || 'image/jpeg');
    }
    if (userdata.verify_id_image_file) {
      verifyIdImageUrl = await uploadMedia('media', `documents/${filePrefix}/verify_id.jpg`, userdata.verify_id_image_file, userdata.verify_id_image_file.type || 'image/jpeg');
    }

    const metadata = {
      first_name: userdata.firstName || userdata.first_name || 'Usuário',
      last_name: userdata.lastName || userdata.last_name || '',
      mobile: userdata.mobile || '',
      usertype: userdata.usertype || 'driver',
      tenant_id: userdata.tenant_id || userdata.tenantId || null,
      cnh: userdata.cnh || '',
      cnh_category: userdata.cnh_category || '',
      cnh_expiry: userdata.cnh_expiry || null,
      profile_image: profileImageUrl,
      license_image: licenseImageUrl,
      license_image_back: licenseImageBackUrl,
      verify_id_image: verifyIdImageUrl,
      approved: userdata.approved !== false
    };

    // Cria o usuário no Supabase Auth usando o cliente isolado sem derrubar a sessão do admin
    const { data: authData, error: authError } = await isolatedClient.auth.signUp({
      email,
      password: rawPass,
      options: {
        data: metadata,
        emailRedirectTo: getAuthRedirectUrl()
      }
    });

    if (authError) {
      console.error('[createUserWithAuth] Auth signUp error:', authError);
      throw authError;
    }

    const createdUserId = authData?.user?.id;

    // Garantir sincronização direta em public.profiles
    if (createdUserId) {
      const supabase = getSupabase();
      if (supabase) {
        await supabase.from('profiles').upsert({
          id: createdUserId,
          email,
          first_name: metadata.first_name,
          last_name: metadata.last_name,
          mobile: metadata.mobile,
          usertype: metadata.usertype,
          tenant_id: metadata.tenant_id,
          cnh: metadata.cnh,
          cnh_category: metadata.cnh_category,
          cnh_expiry: metadata.cnh_expiry,
          profile_image: profileImageUrl,
          license_image: licenseImageUrl,
          license_image_back: licenseImageBackUrl,
          verify_id_image: verifyIdImageUrl,
          approved: metadata.approved
        });
      }
    }

    dispatch({
      type: EDIT_USER_SUCCESS,
      payload: null
    });

    return { 
      success: true, 
      user: authData.user, 
      generatedPassword: userdata.password ? null : rawPass 
    };
  } catch (error) {
    console.error('[createUserWithAuth] Exception:', error);
    dispatch({
      type: EDIT_USER_FAILED,
      payload: error.message || 'Erro ao adicionar usuário'
    });
    return { 
      success: false, 
      error: error.message || 'Erro ao adicionar usuário' 
    };
  }
};

export const addUser = (userdata) => async (dispatch) => {
  return dispatch(createUserWithAuth(userdata));
};

export const updateUserWithAuth = (userId, userdata) => async (dispatch) => {
  dispatch({
    type: EDIT_USER,
    payload: { id: userId, ...userdata }
  });

  try {
    const supabase = getSupabase();
    if (!supabase || !userId) {
      throw new Error('Supabase client ou ID não fornecido');
    }

    // Upload de mídias/documentos se fornecidas como File/Blob
    let profileImageUrl = userdata.profile_image;
    let licenseImageUrl = userdata.license_image || userdata.licenseImage;
    let licenseImageBackUrl = userdata.license_image_back || userdata.licenseImageBack;
    let verifyIdImageUrl = userdata.verify_id_image || userdata.verifyIdImage;

    const filePrefix = `${Date.now()}_${Math.random().toString(36).substring(2, 7)}`;
    if (userdata.profile_image_file) {
      profileImageUrl = await uploadMedia('media', `profiles/${filePrefix}/avatar.jpg`, userdata.profile_image_file, userdata.profile_image_file.type || 'image/jpeg');
    }
    if (userdata.license_image_file) {
      licenseImageUrl = await uploadMedia('media', `documents/${filePrefix}/license_front.jpg`, userdata.license_image_file, userdata.license_image_file.type || 'image/jpeg');
    }
    if (userdata.license_image_back_file) {
      licenseImageBackUrl = await uploadMedia('media', `documents/${filePrefix}/license_back.jpg`, userdata.license_image_back_file, userdata.license_image_back_file.type || 'image/jpeg');
    }
    if (userdata.verify_id_image_file) {
      verifyIdImageUrl = await uploadMedia('media', `documents/${filePrefix}/verify_id.jpg`, userdata.verify_id_image_file, userdata.verify_id_image_file.type || 'image/jpeg');
    }

    const updatePayload = {
      first_name: userdata.firstName || userdata.first_name,
      last_name: userdata.lastName || userdata.last_name,
      mobile: userdata.mobile,
      usertype: userdata.usertype,
      cnh: userdata.cnh,
      cnh_category: userdata.cnh_category || userdata.cnhCategory,
      cnh_expiry: userdata.cnh_expiry || userdata.cnhExpiry || null,
      profile_image: profileImageUrl,
      license_image: licenseImageUrl,
      license_image_back: licenseImageBackUrl,
      verify_id_image: verifyIdImageUrl,
      approved: userdata.approved !== undefined ? userdata.approved : true
    };

    if (userdata.tenant_id !== undefined) {
      updatePayload.tenant_id = userdata.tenant_id || null;
    }

    // Remove campos undefined para não sobrescrever
    Object.keys(updatePayload).forEach(key => updatePayload[key] === undefined && delete updatePayload[key]);

    const { error } = await supabase.from('profiles').update(updatePayload).eq('id', userId);
    if (error) {
      console.error('[updateUserWithAuth] Error:', error);
      throw error;
    }

    dispatch({
      type: EDIT_USER_SUCCESS,
      payload: null
    });

    return { success: true };
  } catch (error) {
    console.error('[updateUserWithAuth] Exception:', error);
    dispatch({
      type: EDIT_USER_FAILED,
      payload: error.message || 'Erro ao atualizar usuário'
    });
    return { success: false, error: error.message || 'Erro ao atualizar usuário' };
  }
};

export const editUser = (id, user) => async (dispatch) => {
  return dispatch(updateUserWithAuth(id, user));
};

export const updateUserCar = (id, data) => async (dispatch) => {
  dispatch({
    type: EDIT_USER,
    payload: data  
  });

  const supabase = getSupabase();
  if (supabase && id) {
    try {
      await supabase.from('profiles').update(data).eq('id', id);
    } catch (e) {}
  }
};

export const updateLicenseImage = (uid, imageBlob, imageType) => async (dispatch) => {
  if (!uid || !imageBlob) return;
  const publicUrl = await uploadMedia('media', `documents/${uid}/${imageType}.jpg`, imageBlob, 'image/jpeg');
  if (publicUrl) {
    const supabase = getSupabase();
    if (supabase) {
      await supabase.from('profiles').update({ [imageType]: publicUrl }).eq('id', uid);
    }
    dispatch({
      type: EDIT_USER,
      payload: uid
    });
  }
};

export const deleteUser = (uid) => async (dispatch) => {
  dispatch({
    type: DELETE_USER,
    payload: uid
  });

  const supabase = getSupabase();
  if (supabase && uid) {
    try {
      await supabase.from('profiles').delete().eq('id', uid);
      const currentUid = store.getState().auth?.profile?.uid;
      if (currentUid === uid) {
        await supabase.auth.signOut();
        dispatch({
          type: USER_DELETED,
          payload: null
        });
      } else {
        dispatch({
          type: DELETE_USER_SUCCESS,
          payload: null
        });
      }
    } catch (e) {
      dispatch({
        type: DELETE_USER_FAILED,
        payload: e
      });
    }
  }
};
